function hasIdentifier(value) {
    return value !== null && value !== undefined && value !== '';
}

export function resolveFavoritableSelectionContext(selection) {
    selection = selection || {};

    if (hasIdentifier(selection.selectedTid)) {
        return { entityType: 'transakcja', entityRef: String(selection.selectedTid) };
    }
    if (hasIdentifier(selection.selectedListingId)) {
        return { entityType: 'property_listing', entityRef: String(selection.selectedListingId) };
    }
    if (hasIdentifier(selection.selectedDid)) {
        return { entityType: 'dzialka', externalId: String(selection.selectedDid) };
    }
    if (hasIdentifier(selection.selectedBid)) {
        return { entityType: 'budynek', externalId: String(selection.selectedBid) };
    }

    var signalContext = selection.selectedSignalContext;
    if (signalContext
        && signalContext.entityType === 'miejscowosc'
        && hasIdentifier(signalContext.entityId)) {
        return { entityType: 'miejscowosc', entityId: parseInt(signalContext.entityId, 10) };
    }

    return null;
}

export function favoriteContextFromToggleAttributes(attributes) {
    attributes = attributes || {};
    return {
        entityType: attributes.entityType || '',
        entityRef: attributes.entityRef || '',
        label: attributes.label || '',
    };
}
